import React from 'react';
import AuthLayout, {
  AuthLayoutProps,
} from '../../../../../components/auth/AuthLayout/AuthLayout';
import imageLandingPage3Desktop from '../../../assets/login_image.webp';

function AuthLayoutFF(props: AuthLayoutProps) {
  return (
    <AuthLayout {...props} imageRight={imageLandingPage3Desktop}>
      {props.children}
    </AuthLayout>
  );
}

export default AuthLayoutFF;
